export default {"src":"/_next/static/image/public/images/ic_bookmark_checked_blue_circle.8cc05e7509738134a5c1b1cb0236f403.svg","height":38,"width":38};